import React from 'react';
import { BoundingBoxField } from '@scale/shared/types/params/textcollection';
import { BoundingBoxFieldAnnotation } from '@scale/shared/types/response/textcollection';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import { Button } from '@material-ui/core';
import { makeStyles } from 'design-system/styles';

interface BoundingBoxFieldSectionProps {
  field: BoundingBoxField;
  annotation: BoundingBoxFieldAnnotation;
  bboxFieldToEdit: string | null;
  setBboxFieldToEdit: (fieldId: string | null) => void;
  disabled?: boolean;
}

export default function BoundingBoxFieldSection(props: BoundingBoxFieldSectionProps) {
  const styles = useStyles();

  return props.bboxFieldToEdit === props.field.field_id ? (
    <Button
      classes={{ root: styles.button }}
      variant="contained"
      onClick={() => props.setBboxFieldToEdit(null)}
    >
      Finish drawing bounding box
    </Button>
  ) : (
    <Button
      classes={{ root: styles.button }}
      variant="contained"
      onClick={() => props.setBboxFieldToEdit(props.field.field_id)}
    >
      {props.annotation.response.length ? 'View / edit' : '+ Add'} bounding box:&nbsp;
      <b>{props.field.title}</b>
    </Button>
  );
}

const useStyles = makeStyles({
  button: {
    backgroundColor: '#FFF',
    color: '#2B99D8',
    textTransform: 'none',
    border: '1px dashed #CCC',
    fontWeight: 'normal',
    fontSize: '13px',
    height: '57px !important',
  },
});
